import {useFilialStore} from '@stores'

export function useGlobalFilial(): readonly [string, (filial: string) => void] {
    const filial = useFilialStore(state => state.filial)
    const definirFilial = useFilialStore(state => state.definirFilial)

    return [filial, definirFilial]
}
